const {
    USER_EMAIL_NOT_EXIST,
    ORGANISATION_DOMAIN_DUPLICITY,
    USER_EMAIL_DUPLICITY,
    LECTURE_START_IN_PAST,
    LECTURE_OUTSIDE_OPENING_HOURS,
    CURRENCY_NOT_ACCEPTED,
    ONE_OF_ONLINE_OR_PHYSICAL_LECTURE_REQUIRED,
} = require('./codes/errorCodes');

/**
 * @readonly
 * @enum {string}
 */
module.exports = {
    [USER_EMAIL_NOT_EXIST.code]: {
        code: 'USER_EMAIL_NOT_EXIST',
        fieldName: 'email',
        description: 'User with requested email does not exist.',
    },
    [ORGANISATION_DOMAIN_DUPLICITY.code]: {
        code: ORGANISATION_DOMAIN_DUPLICITY.code,
        fieldName: 'domain',
        description: 'Office with requested domain name already exists.',
    },
    [USER_EMAIL_DUPLICITY.code]: {
        code: USER_EMAIL_DUPLICITY.code,
        fieldName: 'email',
        description: 'User with requested email already exists.',
    },
    [LECTURE_START_IN_PAST.code]: {
        code: LECTURE_START_IN_PAST.code,
        fieldName: 'start',
        description: 'Lecture start is in the past.',
    },
    [LECTURE_OUTSIDE_OPENING_HOURS.code]: {
        code: LECTURE_OUTSIDE_OPENING_HOURS.code,
        fieldName: 'start',
        description: 'Lecture start is in the past.',
    },
    [CURRENCY_NOT_ACCEPTED.code]: {
        code: CURRENCY_NOT_ACCEPTED.code,
        fieldName: 'pricingOptions',
        description: 'Unsupported currency. This office does not accept the currency.',
    },
    [ONE_OF_ONLINE_OR_PHYSICAL_LECTURE_REQUIRED.code]: {
        code: ONE_OF_ONLINE_OR_PHYSICAL_LECTURE_REQUIRED.code,
        fieldName: 'onlineLectureCheckboxGroupOption',
        description: 'One of online or physical lecture property has to be preset.',
    },
    VAT_VIES_INVALID: {
        code: 'VAT_VIES_INVALID',
        fieldName: 'vatNumber',
        description: 'This vat number is not valid according to VIES.',
    },
    VAT_VIES_ERROR: {
        code: 'VAT_VIES_ERROR',
        fieldName: 'vatNumber',
        description: 'VIES is currently down. Wait a minute and try again later.',
    },
};
